module.exports = __webpack_public_path__ + "img/license.1fa9b431.png";